import { getMessaging, getToken } from "firebase/messaging";
import { initializeApp } from "firebase/app";
import api from "./api";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCYbTkBIcEpclsvrRomH5wG7clG4RB8LNA",
  authDomain: "adastra-3e652.firebaseapp.com",
  projectId: "adastra-3e652",
  storageBucket: "adastra-3e652.appspot.com",
  messagingSenderId: "1069540184137",
  appId: "1:1069540184137:web:50b43a70f41f964a30af98",
};

const VAPID_KEY =
  "BE-i-XOArGvgyEaMr6NVzZO8fAnlROKtAbdqZCpQIHe9jBi_BwxGtUPC9w45wKrz7C8jkhTus37nolzThkRaFmM";

class NotificationService {
  constructor() {
    this.app = initializeApp(firebaseConfig);
    this.messaging = getMessaging(this.app);
  }

  init = async () => {
    try {
      const token = await getToken(this.messaging, { vapidKey: VAPID_KEY });
      api.updateNotificationToken(token);
    } catch (error) {
      console.log("error", error);
    }
  };

  removeToken = () => {
    api.updateNotificationToken(null);
  };
}

export default new NotificationService();
